import { SCOPES } from 'constants/roles';

export default [
  {
    label: 'label.my_preferences',
    name: 'my-preferences',
    url: '/professional/settings/my-preferences/',
    initial: '/professional/settings/my-preferences/profile/personal/',
    navigationIcon: 'far fa-user-md',
    scope: SCOPES.INSTANCE_STAFF,
    pages: [
      {
        label: 'label.profile',
        navigationIcon: 'far fa-address-card',
        name: 'my-preferences-personal',
        type: 'section',
        url: '/professional/settings/my-preferences/profile/',
        scope: SCOPES.INSTANCE_STAFF,
        pages: [
          {
            label: 'label.personal',
            name: 'my-preferences-personal',
            navigationIcon: '',
            url: '/professional/settings/my-preferences/profile/personal/',
            scope: SCOPES.INSTANCE_STAFF,
          },
          {
            label: 'label.picture',
            name: 'my-preferences-profile-picture',
            navigationIcon: '',
            url: '/professional/settings/my-preferences/profile/profile-picture/',
            scope: SCOPES.INSTANCE_STAFF,
          },
          {
            label: 'label.professional_biography',
            name: 'my-preferences-professional-biography',
            navigationIcon: '',
            url: '/professional/settings/my-preferences/profile/professional-biography/',
            scope: SCOPES.INSTANCE_STAFF,
          },
          {
            label: 'label.external_links',
            name: 'my-preferences-external-links',
            navigationIcon: '',
            url: '/professional/settings/my-preferences/profile/external-links/',
            scope: SCOPES.INSTANCE_STAFF,
          },
        ],
      },
      {
        label: 'label.settings',
        navigationIcon: 'far fa-sliders-v',
        name: 'my-preferences-settings-status',
        type: 'section',
        url: '/professional/settings/my-preferences/settings/',
        scope: SCOPES.INSTANCE_STAFF,
        pages: [
          {
            label: 'label.personal_roles',
            name: 'my-preferences-personal-roles',
            navigationIcon: '',
            url: '/professional/settings/my-preferences/settings/personal-roles/',
            scope: SCOPES.INSTANCE_OWNER,
          },
          {
            label: 'label.change_password',
            name: 'my-preferences-change-password',
            navigationIcon: '',
            url: '/professional/settings/my-preferences/settings/change-password/',
            scope: SCOPES.INSTANCE_STAFF,
          },
          {
            label: 'label.change_email',
            name: 'my-preferences-change-email',
            navigationIcon: '',
            url: '/professional/settings/my-preferences/settings/change-email/',
            scope: SCOPES.INSTANCE_STAFF,
          },
          {
            class: 'is-delete',
            navigationIcon: '',
            label: 'label.deactivate_account',
            name: 'my-preferences-settings-status',
            url: '/professional/settings/my-preferences/settings/status/',
            scope: SCOPES.INSTANCE_STAFF,
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/settings/navigation-settings-my-preferences.js